import React from 'react';

import { useUserMetrics } from 'dashboards/hooks/useUserMetrics';

import { Select, SelectProps } from 'components/Select/Select';

type MetricOption = {
  value: string;
  label: string;
};

type MetricSelectProps = Omit<
  SelectProps<MetricOption>,
  'value' | 'onChange' | 'defaultValue'
> & {
  value?: string;
  defaultValue?: string;
  onChange: (value: string | null) => void;
};

export function MetricSelect({
  value,
  defaultValue,
  onChange,
  ...props
}: MetricSelectProps) {
  const { data, isLoading } = useUserMetrics();

  const options = React.useMemo<MetricOption[]>(
    () =>
      data
        ? data.data
            .map(({ name }) => ({
              value: name,
              label: name,
            }))
            .sort((a, b) => (a.label < b.label ? -1 : 1))
        : [],
    [data]
  );

  return (
    <Select
      {...props}
      value={value ? { label: value, value } : undefined}
      defaultValue={
        defaultValue ? { label: defaultValue, value: defaultValue } : undefined
      }
      options={options}
      onChange={(option) =>
        option ? onChange(option.value) : onChange(option)
      }
      isLoading={isLoading}
    />
  );
}
